export enum TContainerVariant {
  normal = 'normal',
  small = 'small',
}
